import type { CSSProperties, SVGProps } from 'react'
import React from 'react'

export const svgIconStyles: CSSProperties = {
  fill: 'currentColor',
  display: 'inline-block',
  fontSize: '1.2857142857142856rem',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  flexShrink: 0,
  userSelect: 'none',
}

const defaultSizeStyles: CSSProperties = {
  width: '1em',
  height: '1em',
}

/** Plain SVG wrapper with MUI-equivalent default styles. Drop-in replacement for the old MUI styled('svg'). */
export const StyledSvg = (props: SVGProps<SVGSVGElement>) => {
  const { className, style, ...rest } = props
  const hasClassName = className && className.length > 0
  const sizeStyles = hasClassName ? {} : defaultSizeStyles
  return React.createElement('svg', { className, ...rest, style: { ...svgIconStyles, ...sizeStyles, ...style } })
}
